<script>
  import { Link } from 'svelte-navigator'
  import { ROUTES } from '../constants/constants'
</script>

<h2>Chi siamo</h2>
<p>
  Siamo un portale che funge da base informativa sugli strumenti al servizio della <strong
    >mobilità sostenibile</strong
  >
  in un contesto transfrontaliero nella provincia di Varese, con lo scopo di favorire
  <strong>pratiche di buona governance sul territorio</strong>.
</p>

<div class="links">
  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.1 1C9.1 0.668629 8.83137 0.4 8.5 0.4L3.1 0.4C2.76863 0.4 2.5 0.668629 2.5 1C2.5 1.33137 2.76863 1.6 3.1 1.6L7.9 1.6V6.4C7.9 6.73137 8.16863 7 8.5 7C8.83137 7 9.1 6.73137 9.1 6.4V1ZM1.42426 8.92426L8.92426 1.42426L8.07574 0.575736L0.575736 8.07574L1.42426 8.92426Z"
      fill="#313131"
    />
  </svg><a href="https://www.comune.varese.it/hh/index.php" target="_blank">Comune di Varese</a>

  <br />

  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.1 1C9.1 0.668629 8.83137 0.4 8.5 0.4L3.1 0.4C2.76863 0.4 2.5 0.668629 2.5 1C2.5 1.33137 2.76863 1.6 3.1 1.6L7.9 1.6V6.4C7.9 6.73137 8.16863 7 8.5 7C8.83137 7 9.1 6.73137 9.1 6.4V1ZM1.42426 8.92426L8.92426 1.42426L8.07574 0.575736L0.575736 8.07574L1.42426 8.92426Z"
      fill="#313131"
    />
  </svg><a href="https://interreg-italiasvizzera.eu/" target="_blank">Interreg</a>

  <br />

  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.1 1C9.1 0.668629 8.83137 0.4 8.5 0.4L3.1 0.4C2.76863 0.4 2.5 0.668629 2.5 1C2.5 1.33137 2.76863 1.6 3.1 1.6L7.9 1.6V6.4C7.9 6.73137 8.16863 7 8.5 7C8.83137 7 9.1 6.73137 9.1 6.4V1ZM1.42426 8.92426L8.92426 1.42426L8.07574 0.575736L0.575736 8.07574L1.42426 8.92426Z"
      fill="#313131"
    />
  </svg><Link
    style="display: inline-block; text-decoration: none; color: #313131; font-size: 14px; border-bottom: 4px solid #00fff0; margin-bottom: 0.25rem;"
    to={ROUTES.privacyPolicy}>Privacy Policy</Link
  ><br />
</div>

<img src="img/AsseV_GovernaTI-VA.png" alt="logo Interreg" />

<p style="font-size: 80%; margin-bottom: 10px;">
  Mobility expertise and powered by <a href="https://www.citec.ch/it/">Citec</a>
  <br />
  Designed and developed by <a href="https://accurat.it/">Accurat</a>
</p>

<style>
  p {
    margin: 3rem 0;
  }

  .links {
    margin-bottom: 3rem;
  }

  a {
    display: inline-block;
    text-decoration: none;
    color: #313131;
    font-size: 14px;
    border-bottom: 4px solid #00fff0;
    margin-bottom: 0.25rem;
  }

  svg {
    padding-right: 0.75rem;
  }

  img {
    max-width: 50%;
  }
</style>
